import React from "react"
import styled, { css } from "styled-components"
import moment from "moment"
import { find, get, debounce } from "lodash"
import { media } from "../../../../components/mediaStyles"
import { colors } from "../../../../components/Color"
import { Button as AntdButton } from "antd"

const Picker = styled.div`
  position: fixed;
  display: flex;
  width: 100%;
  height: 200px;
  bottom: 0;
  left: 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  z-index: 99999;
  background: white;
  border-radius: 4px;
  margin-top: 50px;

  ${media.small`
    position: absolute;
    transform: translateY(100%);
    left: 0;
    bottom: -5px;
    width: 400px;
    height: 180px;
    margin-top: 0px;
  `}
`

const DayPicker = styled.div`
  height: 100%;
  width: 50%;
  overflow: scroll;
  text-align: center;

  ${media.small`
    width: 50%;
  `}
`

const PickableElement = styled.div`
  font-family: GT America, sans-serif;
  font-weight: ${props => (props.selected ? 600 : 300)};
  font-size: ${props => (props.selected ? 18 : 15)}px;
  transition: all 0.2s ease-out;

  :last-child {
    margin-bottom: 75%;
  }
  :first-child {
    margin-top: 75%;
  }

  ${media.largerPhone`
  :first-child {
    margin-top: 60%;
  }
  :last-child {
    margin-bottom: 60%;
  }
  
  `}

  ${media.small`
    :first-child {
      margin-top: 75%;
    }
    :last-child {
      margin-bottom: 50%;
      margin-bottom: 75%;
    }

    ${props =>
      !props.selected &&
      css`
        &:hover {
          font-weight: 450;
          cursor: pointer;
        }
      `}
  
  `}
`

const TopBar = styled.div`
  background: ${colors.paleBeige};
  position: absolute;
  box-shadow: 0 -5px 4px 0 rgba(0, 0, 0, 0.11);
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  top: -45px;
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 15px;

  ${media.small`
    box-shadow: unset;
    background: transparent;
    padding-right: 0px;
    bottom: -45px;
    top: unset;
  `}
`
const Button = styled(AntdButton)`
  color: black;
  font-family: GT America, sans-serif;

  &:hover {
    color: ${colors.teal} !important;
    border-color: ${colors.teal} !important;
  }
`

const SelectionIndicator = styled.div`
  position: absolute;
  height: 36px;
  width: 90%;
  pointer-events: none;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  border-top: 1px solid black;
  border-bottom: 1px solid black;
`

export default class DatePicker extends React.Component {
  elementHeight = 0
  state = {}

  constructor(props) {
    super(props)
    moment.locale("de")
  }

  months() {
    return []
  }

  componentDidMount() {
    this.elementHeight = this.dayPicker.children[0].clientHeight

    this.setState(
      {
        day: this.props.day
          ? `${parseInt(this.props.day)}`
          : `${moment().date()}`,
        month: this.props.month
          ? `${moment.months()[parseInt(this.props.month) - 1]}`
          : `${moment.months()[moment().month()]}`,
        year: this.props.year || `${moment().year()}`,
      },
      () => {
        this.scrollToPoint(this.dayPicker, this.state.day)
        this.scrollToPoint(this.monthPicker, this.state.month)
        this.scrollToPoint(this.yearPicker, this.state.year)
      }
    )
  }

  scrollToPoint(element, value) {
    const currentIndex = find(
      element.children,
      child => child.innerHTML === `${value}`
    )
    window.scrollTarget = element
    var top =
      get(currentIndex, "offsetTop", 0) -
      element.clientHeight / 2 +
      this.elementHeight / 2

    element.scrollTo({
      top,
      behavior: "smooth",
    })

    // First try to reduce jumping at the end of the list with immense scrolling
    // if (element.scrollTop !== top) {
    //   setTimeout(() => {
    //     element.scrollTop = top
    //   }, 1000)
    // }
  }

  onScroll = (scrollContainer, stateVariable) => {
    const index = Math.min(
      Math.floor(scrollContainer.scrollTop / this.elementHeight),
      scrollContainer.children.length - 1
    )
    const newValue = get(
      scrollContainer.children[index],
      ["innerHTML"],
      this.state[stateVariable]
    )

    this.setState({ [stateVariable]: newValue })
    this.scrollToPoint(scrollContainer, newValue)

    if (stateVariable === "month") {
      this.props.updateValue(
        stateVariable,
        moment.months().indexOf(newValue) + 1
      )
    } else {
      this.props.updateValue(stateVariable, newValue)
    }
  }

  onScrollDebounceYear = debounce((scrollContainer, stateVariable) => {
    this.onScroll(scrollContainer, stateVariable)
  }, 100)
  onScrollDebounceMonth = debounce((scrollContainer, stateVariable) => {
    this.onScroll(scrollContainer, stateVariable)
  }, 100)
  onScrollDebounceDay = debounce((scrollContainer, stateVariable) => {
    this.onScroll(scrollContainer, stateVariable)
  }, 100)

  selectValue = element => value => () => {
    this.setState({ [element]: value })
    this.scrollToPoint(this[`${element}Picker`], value)

    if (element === "month") {
      this.props.updateValue(element, moment.months().indexOf(value) + 1)
    } else {
      this.props.updateValue(element, value)
    }
  }

  render() {
    const currentYear = moment().get("year")
    return (
      <React.Fragment>
        <Picker>
          <TopBar>
            <Button
              onClick={event => this.props.onClose(event, { ...this.state })}
            >
              Fertig
            </Button>
          </TopBar>
          <DayPicker
            ref={dayPicker => {
              this.dayPicker = dayPicker
            }}
            onScroll={() => this.onScrollDebounceDay(this.dayPicker, "day")}
          >
            {Array(31)
              .fill(1)
              .map((_, index) => (
                <PickableElement
                  key={"daypicker-" + index}
                  selected={this.state.day === `${index + 1}`}
                  onClick={this.selectValue("day")(index + 1)}
                >
                  {index + 1}
                </PickableElement>
              ))}
          </DayPicker>
          <DayPicker
            ref={monthPicker => (this.monthPicker = monthPicker)}
            onScroll={() =>
              this.onScrollDebounceMonth(this.monthPicker, "month")
            }
          >
            {moment.months().map(month => (
              <PickableElement
                selected={this.state.month === month}
                key={"monthpicker-" + month}
                onClick={this.selectValue("month")(month)}
              >
                {month}
              </PickableElement>
            ))}
          </DayPicker>
          <DayPicker
            ref={yearPicker => (this.yearPicker = yearPicker)}
            onScroll={() => this.onScrollDebounceYear(this.yearPicker, "year")}
          >
            {Array(75)
              .fill(1)
              .map((_, index) => (
                <PickableElement
                  key={"yearPicker-" + index}
                  selected={this.state.year === `${currentYear - 70 + index}`}
                  onClick={this.selectValue("year")(currentYear - 70 + index)}
                >
                  {currentYear - 70 + index}
                </PickableElement>
              ))}
          </DayPicker>
          <SelectionIndicator />
        </Picker>
      </React.Fragment>
    )
  }
}
